import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
}

export const Container: FC<ContainerProps> = ({ children, className }): ReactNode => {
    return (
        <div className={cn('mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-10', className)}>
            {children}
        </div>
    )
}
